import { Box, Typography } from "@mui/material"

export function PdfTaskPlaceholder({ status, side }) {
    return (
        <Box
            sx={{
                minHeight: "108px",
                border: "1px dashed",
                borderColor: getPlaceholderBorderColor(status, side),
                borderRadius: "8px",
                bgcolor: "rgba(255,255,255,0.55)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                px: "20px",
            }}
        >
            <Typography sx={{ fontSize: "10px", color: getPlaceholderTextColor(status, side) }}>
                {getPlaceholderLabel(status, side)}
            </Typography>
        </Box>
    )
}

function getPlaceholderLabel(status, side) {
    if (status === "removed" && side === "right") return "Removed From This Version"
    if (status === "unchanged" && side === "left") return "No Changes In This Version"
    return "Not Found In This Version"
}

function getPlaceholderBorderColor(status, side) {
    if (status === "removed" && side === "right") return "#f1b7b7"
    return "#d6dde5"
}

function getPlaceholderTextColor(status, side) {
    if (status === "removed" && side === "right") return "#9b2c2c"
    return "#7b8794"
}
